export default __webpack_public_path__ + "static/wolfflabs-logo-600-35946d38ae42fff3b9b363d8c0a9b6ef.png";